import React from "react";
import FindAnArtistLandingPage from "./FindAnArtistLandingPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface FindAnArtistLandingPageContainerProps extends RouteProps, withValidUserRoleProps {}

const FindAnArtistLandingPageContainer = (props: FindAnArtistLandingPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <FindAnArtistLandingPage title={getTitle()} category={getType()}/>;
};

export default withValidUserRole(FindAnArtistLandingPageContainer);
